module.exports = "/images/help_support_v2.jpg?3defbe85822347af6a2484ae5432e525";